module.exports = __webpack_public_path__ + "img/school.903dc3dd.png";